export default __webpack_public_path__ + "static/media/tarora.ae4401a2.jpg";